<div
  #pickerDate
  class="picker-date"></div>

@if (displayTime) {
  <div class="picker-time">
    <div class="time">
      <input
        #hoursInput
        pplInput
        class="time-input"
        autocomplete="off"
        [value]="hoursValue"
        (keyup)="onHoursKeyUp($event)"
        (blur)="onHoursBlur()" />
      <div class="colon">:</div>
      <input
        #minutesInput
        pplInput
        class="time-input"
        autocomplete="off"
        [value]="minutesValue"
        (keyup)="onMinutesKeyUp($event)"
        (blur)="onMinutesBlur()" />
      @if (!is24HourSystem) {
        <ppl-select
          #periodSelect
          [options]="timePeriods"
          [value]="selectedTimePeriod"
          (valueChange)="onTimePeriodChange($event)">
        </ppl-select>
      }
    </div>
    @if (displayPlanner) {
      <button
        type="button"
        pplButton
        pplButton1
        pplButtonSmall
        pplPopoverClose
        tabindex="-1"
        (click)="onPlannerClick()">
        {{ appointmentPlanner }}
      </button>
    }
  </div>
}

<div class="picker-actions">
  @if (displayTime) {
    <button
      type="button"
      #submitButton
      pplButton
      pplButton1
      pplButtonSmall
      pplButtonBold
      pplButtonFocusable
      pplPopoverClose
      (click)="onSubmitClick()"
      (keyup)="onSubmitKeyUp($event)">
      {{ submitButtonLabel || ok }}
    </button>
  }
  @if (!displayTime && displayToday) {
    <button
      type="button"
      pplButton
      pplButton1
      pplButtonSmall
      pplButtonBold
      pplButtonFocusable
      pplPopoverClose
      (click)="todayClick.emit()">
      {{ today }}
    </button>
  }
  @if (displayRemove) {
    <button
      type="button"
      [class.full-width]="fullWidthButton"
      pplButton
      pplButton5
      pplButtonSmall
      pplButtonBold
      pplButtonFocusable
      pplPopoverClose
      (click)="onRemoveClick()">
      {{ remove }}
    </button>
  }
</div>

<div
  #icons
  style="display: none">
  <ppl-icon
    class="prev-icon"
    svgIcon="rowfull-left"
    height="12px"
    [useSvg]="true"></ppl-icon>
  <ppl-icon
    class="next-icon"
    svgIcon="rowfull-right"
    height="12px"
    [useSvg]="true"></ppl-icon>
</div>
